
    import '/opt/buildhome/repo/packages/x/components/folder/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["folder-demo-basic","folder-demo-custom-service","folder-demo-file-controlled","folder-demo-fully-controlled","folder-demo-searchable","folder-demo-custom-icons","folder-demo-preview-render","folder-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/folder/index.zh-CN.md?type=demo')
};